import { render, staticRenderFns } from "./CmgRestaurantAddressItem.vue?vue&type=template&id=9c28c35c&scoped=true&lang=pug"
import script from "./cmg-restaurant-address-item.ts?vue&type=script&lang=ts&external"
export * from "./cmg-restaurant-address-item.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgRestaurantAddressItem.vue?vue&type=style&index=0&id=9c28c35c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c28c35c",
  null
  
)

export default component.exports